import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useDebounceCallback } from "usehooks-ts";
import TextField from "@mui/material/TextField";
import { useCsValue, useCsValueApi, useSyncInfo, } from "@plansoft-configuration-renderer/framework";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";
export function ValueQuantity() {
    const { setQuantity } = useCsValueApi();
    const value = useCsValue();
    const t = useUiTranslator();
    const { isSyncing } = useSyncInfo();
    const [isFocused, setIsFocused] = useState(false);
    const [localQty, setLocalQty] = useState(formatValueQuantity(value.quantity));
    const setQuantityDebounced = useDebounceCallback(setQuantity, 250);
    useEffect(() => {
        if (isFocused) {
            return;
        }
        if (isSyncing) {
            return;
        }
        setLocalQty(formatValueQuantity(value.quantity));
    }, [value.quantity, isSyncing, isFocused]);
    function handleChange(e) {
        const qty = parseValueQuantity(e.target.value);
        setLocalQty(e.target.value);
        setQuantityDebounced(qty);
    }
    function handleBlur(_e) {
        setIsFocused(false);
    }
    function handleFocus(_e) {
        setIsFocused(true);
    }
    // only selected values can be edited
    const isDisabled = !value.isSelected;
    return (_jsx(TextField, { fullWidth: true, value: localQty, onChange: handleChange, onFocus: handleFocus, onBlur: handleBlur, type: "number", placeholder: t("ConfigurationRenderer:ValueQuantity.placeholder", "Quantity"), slotProps: { htmlInput: { min: 0 } }, sx: { minWidth: "6rem", visibility: isDisabled ? "hidden" : "visible" }, size: "small" }));
}
function parseValueQuantity(value) {
    return parseInt(value, 10);
}
function formatValueQuantity(value) {
    return value == null ? "" : value.toString();
}
//# sourceMappingURL=ValueQuantity.js.map